import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/guide-tips/fill-out-prescription/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
